<template>
    <div>
        auth
    </div>
</template>